import { render, staticRenderFns } from "./FlightsListItemSkeleton.vue?vue&type=template&id=40ba15a2"
import script from "./FlightsListItemSkeleton.vue?vue&type=script&lang=js"
export * from "./FlightsListItemSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports